import { useSelector } from 'react-redux'
import { AlertGroup } from '../types/Alerts'
import { RootState } from '../redux'

export default function useDeviceAlertRules(): AlertGroup[] {
  return useSelector((state: RootState) => state.devices.alertRules)
}
